var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import moment from 'moment';
import { useMutation, useQueryClient } from 'react-query';
import { uuid } from '../utils';
import { CacheKeys } from '../constants';
import { useChuckClientContext } from './useChuckClientContext';
import { useAPI } from './useAPI';
export const useMessageCreation = () => {
    const queryClient = useQueryClient();
    const { post } = useAPI();
    const { client } = useChuckClientContext();
    return useMutation((vars) => post({
        url: vars.assistant
            ? `/assistants/${vars.assistant}/messages`
            : `/messages`,
        data: {
            thread: vars.thread,
            channel: vars.channel,
            visibleTo: vars.visibleTo,
            visibility: vars.visibility,
            messages: vars.messages.map((message) => (Object.assign(Object.assign({ type: message.type, data: message.type === 'file'
                    ? message.data.map(({ id }) => id)
                    : message.data }, (message.tags ? { tags: message.tags } : {})), (message.localId ? { localId: message.localId } : {}))))
        }
    }).then((res) => res.data), {
        onMutate: (_a) => __awaiter(void 0, void 0, void 0, function* () {
            var { messages } = _a, vars = __rest(_a, ["messages"]);
            const { thread, visibility } = vars;
            yield queryClient.cancelQueries([
                CacheKeys.MESSAGES,
                thread,
                visibility
            ]);
            const prev = queryClient.getQueryData([
                CacheKeys.MESSAGES,
                thread,
                visibility
            ]);
            const orderedMessages = [...messages].reverse();
            const ids = orderedMessages.map((message) => { var _a; return (_a = message.localId) !== null && _a !== void 0 ? _a : uuid(); });
            if (prev)
                queryClient.setQueryData([CacheKeys.MESSAGES, thread, visibility], () => {
                    return Object.assign(Object.assign({}, prev), { pages: prev.pages.map((page, index) => (Object.assign(Object.assign({}, page), { records: [
                                ...(index === 0
                                    ? orderedMessages.map((message, index) => (Object.assign(Object.assign(Object.assign({}, vars), message), { id: ids[index], createdAt: moment().toISOString(), updatedAt: moment().toISOString() })))
                                    : []),
                                ...page.records
                            ] }))) });
                });
            return { ids };
        }),
        onSuccess: (data, vars, context) => {
            const { thread, visibility } = vars;
            const prev = queryClient.getQueryData([
                CacheKeys.MESSAGES,
                thread,
                visibility
            ]);
            if (prev)
                queryClient.setQueryData([CacheKeys.MESSAGES, thread, visibility], () => {
                    var _a;
                    const next = Object.assign(Object.assign({}, prev), { pages: prev.pages.map((page) => (Object.assign(Object.assign({}, page), { records: page.records
                                .map((record) => (context === null || context === void 0 ? void 0 : context.ids.includes(record.id))
                                ? data.pop()
                                : record)
                                .sort((a, b) => moment(b.createdAt).valueOf() -
                                moment(a.createdAt).valueOf()) }))) });
                    if (data.length)
                        (_a = next.pages[0]) === null || _a === void 0 ? void 0 : _a.records.unshift(...data);
                    return next;
                });
        },
        onError: (err, vars, context) => {
            const { thread, visibility } = vars;
            const prev = queryClient.getQueryData([
                CacheKeys.MESSAGES,
                thread,
                visibility
            ]);
            if (prev)
                queryClient.setQueryData([CacheKeys.MESSAGES, thread, visibility], () => (Object.assign(Object.assign({}, prev), { pages: prev.pages.map((page) => (Object.assign(Object.assign({}, page), { records: page.records.filter(({ id }) => !(context === null || context === void 0 ? void 0 : context.ids.includes(id))) }))) })));
            client.captureException(err);
        }
    });
};
//# sourceMappingURL=useMessageCreation.js.map